//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { TRUSTPILOT_URL } from '~/const/3rd';
export default {
  name: 'TrustPilot',
  mounted: function mounted() {
    this.asyncScript(TRUSTPILOT_URL).then(function () {}).catch(function (err) {
      console.error('TRUSTPILOT_URL FAILED', err);
    });
  }
};